import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/derivacion`;
const readUrl = (url = "") => `${urlBase}/${url}`;

export const postDerivacion = async (derivacion) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(``), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(derivacion),
  });

  res = await parseJSON(res);

  return res.success;
};

export const patchDerivacion = async (itemId, derivacion) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`${itemId}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(derivacion),
  });

  res = await parseJSON(res);

  return res.success;
};

export const getDerivaciones = async (id) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`?notaDePedidoId=${id}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);

  return res.success;
};

export const deleteDerivacionCandidatoRelacion = async (derivacionId, candidatoId) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`${derivacionId}/${candidatoId}`), {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);

  return res.success;
};
